import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye, EyeOff } from '@icons';
import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useState, } from 'react';
import { isDark } from '../common/utils';
import { Input } from '../input/input';
import styles from './password.module.scss';
const Password = ({ RTL, size = 'sm', onChange, border = false, placeholder = 'Please enter the password...', }) => {
    const [type, setType] = useState('password');
    const [showPassword, setShowPassword] = useState(false);
    const isDarkMode = useMemo(() => isDark(), []);
    useEffect(() => {
        if (showPassword) {
            setType('text');
        }
        else {
            setType('password');
        }
    }, [showPassword]);
    const wrapperClass = useMemo(() => classNames(styles.wrapper, {
        [styles[size]]: true,
        [styles.RTL]: RTL,
        [styles.dark]: isDarkMode,
    }), [isDarkMode]);
    const unMaskClass = useMemo(() => classNames(styles.unmask_icon, {
        [styles[size]]: true,
        [styles.rtl]: RTL,
    }), []);
    const togglePassword = useCallback(() => {
        setShowPassword(prev => !prev);
    }, []);
    return (_jsxs("div", { className: wrapperClass, children: [_jsx("div", { className: styles.input_wrapper, children: _jsx(Input, { type: type, onChange: onChange, size: size, border: border, RTL: RTL, placeholder: placeholder, transparentBg: true, controlled: true }) }), showPassword ? (_jsx("span", { className: unMaskClass, onClick: togglePassword, role: "button", "aria-label": "hide password", children: _jsx(EyeOff, {}) })) : (_jsx("span", { className: unMaskClass, onClick: togglePassword, role: "button", "aria-label": "show password", children: _jsx(Eye, {}) }))] }));
};
export { Password };
